import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
  avatar10,
  avatar11,
  avatar12,
  avatar13,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  userProfile,
} from '../../assets/images'

export default function Team() {

  return (
    <>
      <Breadcrumb title="Team" path="Team" />
      <div className='md:mb-30 mb-15 w-full'>
        <input
          type='text'
          name='search'
          id='search'
          placeholder='Search...'
          className='bg-bg-light border border-border w-full py-[6px] pl-20 pr-30 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
        />
      </div>
      <div className='grid xxl:grid-cols-4 md:grid-cols-2 md:gap-30 gap-15'>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Web Development Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar11} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Susie Willis
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              ReactJS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Angular
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              VueJS
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Marketing Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar12} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Debra Stewart
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Social
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Twitter
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Sales Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar13} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Erin Gonzales
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Photoshop
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Javascript
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Web Designing Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Marshall Nichols
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Photoshop
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Javascript
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Web Development Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar11} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Susie Willis
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              ReactJS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Angular
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              VueJS
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Marketing Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar12} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Debra Stewart
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Social
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Twitter
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Sales Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={avatar13} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Erin Gonzales
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Photoshop
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Javascript
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
        <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
          <p className='font-medium text-[16px]/[19.2px] mb-30'>
            Web Designing Team
          </p>
          <div className='border border-border rounded-full p-1 mb-2'>
            <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
          </div>
          <p className='font-medium text-[16px]/[20px] text-primary'>
            Marshall Nichols
          </p>
          <p className='text-text-secondary mb-20'>
            Team Lead
          </p>
          <div className='flex items-center gap-5 mb-20'>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Photoshop
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              HTML/CSS
            </span>
            <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              Javascript
            </span>
          </div>
          <div className="flex items-center gap-5 mb-20">
            <p className='text-text-secondary font-medium'>Employees : </p>
            <ul className="flex items-center">
              <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
            </ul>
          </div>
          <p className='text-[16px]/[24px] text-text-secondary'>
            1 Lead, 3 Employees
          </p>
        </div>
      </div>
    </>
  )
}
